














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import { isDemoAccount,getMobilexdomain } from '@/utils/utils'
import VipList from './components/VipList.vue';
import i18n from '@/lang/index';
import AdManageApi from '@/apis/advertManage/admanage';
import {createUnionAdComponent} from 'union-ad-vue';
import BannerAdLists from '@/views/Home/ktpStudentHome/components/bannerAdLists.vue';
import urlConfig from '@/Configurations/urlConfig';
import { couldStartTrivia } from 'typescript';
import OfficialCard from  '@/components/OfficialAccountCard/officialAccountCard.vue';
import HeadlinesCard from '@/components/OfficialAccountCard/ToutiaoCard.vue';
import ColdKnowlegeCard from '@/components/OfficialAccountCard/ColdKnowlegeCard.vue';

@Component({
  components: {
    VipList,
    UnionAd: createUnionAdComponent(),
    BannerAdLists,
    OfficialCard,
    HeadlinesCard,
    ColdKnowlegeCard
  }
})
export default class ktpMy extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  get token() {
    return window.localStorage.getItem('token');
  }
  //是否显示旧版
  get showOlderVersion():boolean{
    let mobileXDomain = getMobilexdomain() as string;
    if(mobileXDomain==null || mobileXDomain == "" || mobileXDomain.includes('ketangpai.com')){
      return false;
    }
    return false;
  }

  //展示机构后台
  private showJiGouHoutai = false;
  //展示语言切换
  private showSwitchLang = true;
  private nowLang = "zh";

  private infoList: any = this.getItemLists();

  private adShow:boolean = false;//是否显示广告

  private adObject:any = null;
  private adObjectLists:any = [];//广告列表
  private animate:boolean = false;
  private impressionsMap = new Map();//是否被曝光过

  // 点击头部
  detailedInfo() {
    this.$router.push({ path: '/myInfoDetail' });
  }

  getItemLists(){
    let itemLists:any = [];

    let messageNoticeItem =  {
        icon: '',
        vantIcon: 'volume-o',
        text: i18n.t('ktpMy.消息通知'),
        routerDetail: 'messageNotice',
        show:true,
        index:1,
    };

    let myLibraryItem = {
      icon: 'icon-task_outline',
      text: i18n.t('ktpMy.文库'),
      routerDetail: 'myLibrary',
      show:false,
      index:2,
    };

    let myAccountManageItem = {
      icon: '',
      vantIcon: 'contact',
      text: i18n.t('ktpMy.账号管理'),
      routerDetail: 'myAccountManage',
      show:true,
      index:3,
    };

    let vipManagementItem = {
        icon: 'icon-jifen_outline',
        text: i18n.t('ktpMy.VIP管理'),
        routerDetail: '/vipManagement',
        show:true,
        index:4,
    };

    let myTradeRecordItem = {
      icon: 'icon-starrecord_outline',
      text: i18n.t('ktpMy.交易记录'),
      routerDetail: 'myTradeRecord',
      show:true,
      index:5,
    };

    let myMessageSetItem = {
        icon: 'icon-manage_outline',
        text: i18n.t('ktpMy.消息设置'),
        routerDetail: 'myMessageSet',
        show:true,
        index:6,
    };

    let myMechanismItem = {
        icon: 'icon-xuebabangdan_outline',
        text: i18n.t('ktpMy.机构用户认证'),
        routerDetail: 'myMechanism',
        show:true,
        index:7,
    };

    if(urlConfig.privateDeploy){
      itemLists = [
        messageNoticeItem,
        myAccountManageItem,
        myMessageSetItem,
        myMechanismItem,
      ];
    }else{
      itemLists = [
        messageNoticeItem,
        myLibraryItem,
        myAccountManageItem,
        vipManagementItem,
        myTradeRecordItem,
        myMessageSetItem,
        myMechanismItem,
      ];
    }
    return itemLists;
  }

  getInfoListItem(index:number){
    for(let i = 0; i < this.infoList.length; i++){
      if(this.infoList[i].index == index){
        return this.infoList[i];
      }
    }
    return null;
  }

  // list列表点击
  myDetail(index: number) {
    let item = this.getInfoListItem(index);
    if (item.routerDetail === 'myLibrary') {
      window.location.href = 'https://w.ketangpai.com/pages/wenku/index.html'; // 线上环境
    } else {
      /vip/.test(item.routerDetail) ? this.$router.push('/vipManagement') : this.$router.push({ path: '/myAllSetting', query: { detail: item.routerDetail } });
    }
  }

  //进入机构后台
  goJigouHoutai(){
    window.location.href = 'http://jigou.ketangpai.com/#/login?xktptoken='+this.token;
  }

  //前往三节课
  gotoSanjieke(){
    this.$router.push({
      path:'/ktpStudentHome',
    });
  }

  //切换语言
  switchLang(){
     this.$dialog.confirm({
      title: i18n.t('Common.系统提示') as string,
      message: '是否要进行语言切换？',
    }).then(()=>{
      let chooseLanguage = localStorage.getItem('xlanguage');
      chooseLanguage = chooseLanguage && chooseLanguage.replace(/\"/g,"");
      if((chooseLanguage!=null && (chooseLanguage.indexOf('zh')!=-1)) || chooseLanguage == null){
        localStorage.setItem('xlanguage',"en");
        this.nowLang = "en";
        location.reload();
      }else if(chooseLanguage!=null && (chooseLanguage.indexOf('en')!=-1)){
          localStorage.setItem('xlanguage',"zh");
          this.nowLang = "zh";
          location.reload();
      }
    });
  }

  created() {
    if(isDemoAccount(this.$store.state.userInfo.id)){
      this.showJiGouHoutai = true;
    } else {
      this.$store.dispatch('setUserInfo')
    }
    if(!this.showOlderVersion){
      this.getInfoListItem(2).show = false;//不显示文库
      this.getInfoListItem(4).show = false;//不显示会员
    }
    let chooseLanguage = localStorage.getItem('xlanguage');
    chooseLanguage = chooseLanguage && chooseLanguage.replace(/\"/g,"");
    if((chooseLanguage!=null && (chooseLanguage.indexOf('zh')!=-1)) || chooseLanguage == null){
      this.nowLang = "zh";
    }else{
      this.nowLang = chooseLanguage;
    }
    //判断是不是光华管理学院的
    let school = this.$store.state.userInfo.school as string;
    if(school != null && school.indexOf("北京大学光华管理学院")>-1){
      this.showSwitchLang = true;
    }
    //是否显示广告
    //判断是不是老师，是不是学生会员，如果是的话，就不要显示
    let userType = this.$store.state.userInfo.usertype as string;
    if(userType == '0' && this.$store.state.userInfo.isvip == 0){
      this.adShow = true;
    }
  }

  //获取广告的列表
  getAdByLocation(){
    AdManageApi.getAdByLocation({location:2,maxShowCount:3}).then((res:any)=>{
      this.adObject = res.ad;
      this.adObjectLists = res.adLists;//广告的列表
      if(this.adObjectLists && this.adObjectLists.length>0){
        this.adShow = true;
        this.animate = false;
        if(this.adObjectLists.length > 1){

        }else{
          let firstItem = this.adObjectLists[0];
          AdManageApi.collectAdLog({adid:firstItem.id,corpid:firstItem.corpid,type:1,location:3}).then((res1:any)=>{});
        }
        AdManageApi.collectPageLog({location:3});
      }
    });
  }

  /**
   * 前往免费会员领取地方
   */
  gotoFreeVip(){
    window.location.href = 'https://docs.qq.com/form/page/DVXlHU1pGekFxeW5l';
  }

}
